<div
  class="bg-white p-6 rounded-xl flex flex-col gap-2"
  [class.hover:cursor-pointer]="link() && !isInEditMode()"
  (click)="!isInEditMode() && link() && (isRedirectionExternal() ? openModal() : router.navigate([link()]))"
>
  <div class="flex flex-col">
    <p class="!font-bold">{{ title() }}</p>
    @if (subtitle()) {
    <p>{{ subtitle() }}</p>
    }
  </div>
  @if (isInEditMode()) {
  <div class="flex items-center gap-2 self-center hover:cursor-pointer" (click)="$event.stopPropagation()">
    <input
      type="checkbox"
      [attr.id]="'select-card-' + objectId()"
      [attr.name]="'select-card-' + objectId()"
      (change)="isSelected.emit(objectId())"
      class="hover:cursor-pointer"
    />
    <label [attr.for]="'select-card-' + objectId()" class="hover:cursor-pointer"
      >{{ 'components.cardFavorite.deleteFromFavoriteText' | transloco }}</label
    >
  </div>

  } @else { @if (link()) { @if (isRedirectionExternal()) {
  <button
    class="cta text-vinciBlue-600 self-center"
    (click)="openModal()"
  >
    {{ 'components.cardFavorite.checkTextForExternalRedirection' | transloco }}
    <icon [name]="'arrow-right'" [size]="'0.875rem'"></icon>
  </button>
  } @else {
  <a
    class="cta text-vinciBlue-600 self-center"
    [routerLink]="link()"
    >{{ 'components.cardFavorite.checkTextForInternalRedirection' | transloco }}
    <icon [name]="'arrow-right'" [size]="'0.875rem'"></icon
  ></a>
  } } }
</div>

@if(isRedirectionExternal() && isModalOpen() ){
<app-modal
  [title]="'components.cardFavorite.modalTitleForExternalRedirection' | transloco"
  [buttonText]="'components.cardFavorite.modalButtonTextForExternalRedirection' | transloco"
  [text]="textDisclaimer()"
  (closeModal)="closeModal()"
  (completeModal)="goToLink()"
  class="tile-modal"
></app-modal>
}
